import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';


const state = {
    modalGenerateBalanceData: { amount: 0, currency: 0, balance_url: undefined},
    errors: {},
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}